module.exports = __webpack_public_path__ + "img/heart.3c894c89.png";